import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { HideTopNavigationLayout } from '@/layouts/HideTopNavigationLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildCreateIndexView } from '@/views/GuildCreateView'

interface GuildCreateProps {
  locale: string
}

const GuildCreateIndexPage: NextPageWithLayout<GuildCreateProps> = ({ locale }) => {
  const { t } = useTranslate('guild-create')

  return (
    <div className="bg-white">
      <Seo
        /* todo - remove this when the page is live and update the redirect from /create to here */
        noindex
        nofollow={false}
        {...getBasicPageMetaData({
          cloudinaryImagePath: 'v1756153598/angel-studios/seo/angel-opengraph-5',
          cloudinaryTransformation: 'b_rgb:000000',
          description: t('guildCreateIndexMetaDescriptionAngel', 'Submit your film or concept to the Angel Guild.'),
          locale,
          path: paths.guild.create.index,
          title: t('guildCreateIndexTitleAngel', 'Angel Guild Film Submission | Angel'),
        })}
      />
      <GuildCreateIndexView />
    </div>
  )
}

GuildCreateIndexPage.getLayout = (page) => {
  return <HideTopNavigationLayout isDarkMode={false}>{page}</HideTopNavigationLayout>
}

export const getStaticProps = getStaticPropsErrorHandler<GuildCreateProps>(
  { filePath: 'pages/[locale]/guild/create/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'guild-create'])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default GuildCreateIndexPage
